import { ExperienceColor } from '@/lib/schemas/experience-colors';
import { Dot } from '../types';
import { hexToRgb, rgbToHsv } from '@/utils/color-format-convertors';
import { clamp } from '@/utils/clamp';

export function experienceColorsToDots(
  experienceColors: ExperienceColor[]
): Dot[] {
  return experienceColors
    .map((experienceColor) => {
      const rgb = hexToRgb(experienceColor.color.hex);
      const hsv = rgbToHsv(rgb.r, rgb.g, rgb.b);

      return {
        hexColorId: experienceColor.color.hex,
        hue: hsv[0],
        mesh: null,
        ratio: clamp(experienceColor.ratio, 0, 1),
      };
    })
    .sort((a, b) => b.hue - a.hue)
    .map((colorData, hueIndex) => {
      const positionInColorsArray = hueIndex / experienceColors.length;

      return {
        ...colorData,
        hueIndex,
        colorGroupIndex:
          positionInColorsArray < 1 / 3
            ? 0
            : positionInColorsArray < 2 / 3
            ? 1
            : 2,
      };
    });
}
